// extracted by mini-css-extract-plugin
export var galerieContainer = "galerie-images-module--galerie-container--afbd4";
export var galerieImage = "galerie-images-module--galerie-image--a501a";
export var galerieItemContainer = "galerie-images-module--galerie-item-container--fc4c8";
export var galerieItemDescription = "galerie-images-module--galerie-item-description--d7555";
export var galerieItemHeader = "galerie-images-module--galerie-item-header--e5ce9";
export var galerieItemLink = "galerie-images-module--galerie-item-link--8ed80";
export var masonryGrid = "galerie-images-module--masonry-grid--61aab";
export var masonryGridColumn = "galerie-images-module--masonry-grid-column--9d7f0";